<template>
	<div>
		<div class="case-pice"><span class="case-pice-first">企业变更记录</span> <span class="case-pice-and">/</span> <span class="case-pice-second">首页</span></div>
		<div>
			<div class="commom-input-label">会员单位名称：</div>
			<el-input v-model="searchData.companyName" clearable class='common-input-width' size='small' placeholder="请输入会员单位名称"></el-input>
			<div class="commom-input-label" style="margin-left: 20px;">统一社会代码：</div>
			<el-input v-model="searchData.creditCode" clearable class='common-input-width' size='small' placeholder="请输入统一社会代码"></el-input>
			<div class="commom-input-label" style="margin-left: 20px;">处理状态：</div>
			<el-select size='small' class='common-input-width' style='width: 120px;' v-model="searchData.status" clearable placeholder="请选择">
				<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			<el-button size='small' type="primary" style="margin-left: 10px;font-size: 14px;" @click='search()' plain icon="el-icon-search">查询</el-button>
		</div>
		<el-table :data="tableData" border style="width: 100%" stripe height=' calc(100vh - 210px)'>
			<el-table-column label="序号" width="60">
				<template slot-scope="scope">
					{{scope.$index+1}}
				</template>
			</el-table-column>
			<el-table-column prop="operator" show-overflow-tooltip label="姓名">
			</el-table-column>
			<el-table-column prop="certificationNo" show-overflow-tooltip label="学员编号">
			</el-table-column>
			<el-table-column prop="oldCompanyName" min-width="180" show-overflow-tooltip label="原会员单位名称">
			</el-table-column>
			<el-table-column prop="oldCreditCode" min-width="180" show-overflow-tooltip label="原社会统一代码">
			</el-table-column>
			<el-table-column prop="oldCorp" show-overflow-tooltip label="原法人">
			</el-table-column>
			<el-table-column prop="newCompanyName" min-width="180" show-overflow-tooltip label="现会员单位名称">
			</el-table-column>
			<el-table-column prop="newCreditCode" min-width="180" show-overflow-tooltip label="现统一社会代码">
			</el-table-column>
			<el-table-column prop="newCorp" show-overflow-tooltip label="现法人">
			</el-table-column>
			<el-table-column show-overflow-tooltip min-width="180" label="提交时间">
				<template slot-scope="scope">
					<!--<span>{{scope.row.createTime.year}}-{{scope.row.createTime.monthValue | filterTime}}-{{scope.row.createTime.dayOfMonth | filterTime}}</span>
					<span style="margin-left: 10px;">{{scope.row.createTime.hour | filterTime}}:{{scope.row.createTime.minute | filterTime}}:{{scope.row.createTime.second | filterTime}}</span>-->
					<span>{{scope.row.createTime}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="status" show-overflow-tooltip label="处理状态">
				<template slot-scope="scope">
					<span v-if="scope.row.status == 0">未更正</span>
					<span v-else>已更正</span>
				</template>
			</el-table-column>
			<el-table-column fixed="right" label="操作" width="160">
				<template slot-scope="scope">
					<el-button size='mini' type="danger" v-if='scope.row.status == 0' @click='checkMember(scope.row)' plain>更正</el-button>
					<el-button size='mini' type="info" @click='lookMemberInfo(scope.row)' plain>查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pagination-block">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10,20,50,100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalNumber">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import { companyChangeList, companyChangeConfirm } from '../../api/main'
	export default {
		data() {
			return {
				searchData: {
					operator: '',
					creditCode: '',
					status: ''
				},
				options: [{
					label: '全部',
					value: ''
				},{
					label: '未更正',
					value: '0'
				}, {
					label: '已更正',
					value: '1'
				}],
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				totalNumber: 0
			}
		},
		mounted() {
			this.getChangeList();
		},
		methods: {
			getChangeList() {
				companyChangeList({
					companyName:this.searchData.companyName,
					operator: this.searchData.operator,
					creditCode: this.searchData.creditCode,
					current: this.currentPage,
					pageSize: this.pageSize,
					status: this.searchData.status
				}).then(res => {
					console.log(res)
					this.tableData = res.data.records;
					this.totalNumber = parseInt(res.data.total);
				})
			},
			search() {
				this.currentPage = 1;
				this.getChangeList();
			},
			handleSizeChange(data) {
				this.pageSize = data;
				this.getChangeList();
			},
			handleCurrentChange(data) {
				this.currentPage = data;
				this.getChangeList();
			},
			checkMember(row) {
				this.$confirm('确定更正所选项吗？', '企业更正', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					companyChangeConfirm({
						changeId: row.changeId,
						status: "1"
					}).then(res => {
						if(res.code == 1) {
							this.$message({
								type: 'success',
								message: '更正成功!'
							});
							this.search();
						}else{
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消更正'
					});
				});
			},
			lookMemberInfo(row) {
				this.$store.state.companyChangeId = row.changeId;
				this.$router.push('/CompanyChangeDetail')
			},
		}
	}
</script>

<style lang="less">

</style>